module.exports = __webpack_public_path__ + "img/example01.2041dfb8.png";